<template>
	<!--帖子标题 -->
	<div class="tieziInfoBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="backForum">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">云锦金榜</p>
				</div>
			</div>
		</van-sticky>
		<div class="main">
			<div class="wrapper" ref="wrapper">
				<ul class="content">
					<!-- 分类列表 -->
					<li v-for="(item,index) in detialList" :key="index" @click="listClick(index)" :class="index===active?'active':''">{{item.list}}</li>
				</ul>
			</div>
			<div class="detialList_box">
				<ul class="detialList clearfix blockBox" v-for="(item,index) in detialList" v-show="index===active" :key="index">
					<li class="blockLeft" v-for="(item,index) in item.detial" :key="index" @click="jumpBookinfo(item.book_id)" v-if="item.book_id !=0">
						<div class="book_Img">
							<img :src="$api.$BASE_URL_img + item.cover_image" alt="" />
						</div>
						<div class="blockBookInfo">
							<div class="bookName">
								<!-- <p>{{item.name}}</p> -->
								<span class="bookTxtBox" v-if="item.name">
									<van-notice-bar scrollable :text="item.name"></van-notice-bar>
								</span>
								<span class="bookTxtBox" v-else>
									<van-notice-bar scrollable :text="item.name"></van-notice-bar>
								</span>
							</div>
							<div class="auther">
								<span>{{item.author}}</span>
								<p><span>{{Math.floor((item.total_words / 10000) * 100) / 100}}万字</span><span class="wanjie" :class="item.state == '连载中' ? 'txtGreen' : ''">{{item.state}}</span></p></div>
							<!-- <p class="bookType">{{item.name}}</p> -->
							<p class="bookType">{{item.original_name}}-{{item.appetency_name}}-{{item.epoch_name}}-{{item.type_name}}</p>
							<div class="introduction">
								<p><span v-for="(itemtxt,txtIdx) in item.introduce" v-if="txtIdx<12?true:false">{{itemtxt}}</span></p>
							</div>
							<div class="book_button">
								<button v-for="(lableItm,lableIdx) in item.lable_list">{{lableItm.name}}</button>
							</div>
						</div>
					</li>
					<li v-if="item.detial.length ==0" style="text-align: center;line-height: 100px;">
						<img src="../../assets/img/data_null.png" width="80" style="margin-top: 100px;" alt="">
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>


<script>
	import BScroll from "better-scroll";
	export default {
		data() {
			return {
				detialList: [{
						list: "总榜",
						detial: []
					},
					{
						list: "现代言情",
						detial: []
					},
					{
						list: "古代言情",
						detial: []
					},
					{
						list: "幻想言情",
						detial: []
					},
					{
						list: "现代纯爱",
						detial: []
					},
					{
						list: "古代纯爱",
						detial: []
					},
					{
						list: "幻想纯爱",
						detial: []
					},
					
					{
						list: "百合",
						detial: []
					},
					{
						list: "衍生纯爱",
						detial: []
					},
					{
						list: "衍生言情",
						detial: []
					},
					
					{
						list: "无CP",
						detial: []
					},
					
				],
				active: 0,
				detialtext: '总榜'
			};
		},
		created() {
			this.$axios.post(this.$api.ranking_zb).then(res => {
				if(res.status == 200){
					console.log(res.data.data,'res')
					if(res.data.data.length != 0){
						for(var i= 0;i<this.detialList.length;i++){
							this.detialList[0].detial=res.data.data;
						}
					}	
				}
			})
		},
		mounted() {
			this.$nextTick(() => {
				this.scroll = new BScroll(this.$refs.wrapper, { //better-scroll初始化
					scrollY, //竖向滚动
					click: true //滚动区域可触发点击事件
				});
			});
		},
		methods: {
			listClick(index) { //显示隐藏分类详情
				this.active = index;
				this.detialtext = index;
				if(this.active == 7){
					// 百合
					this.slideDataFn(139,7)
				}else if(this.active == 10){
					// 无CP
					this.slideDataFn(167,10)
				}else if(this.active == 1){
					// 现代言情
					this.slideDataFn(93,1)
				}else if(this.active == 2){
					// 古代言情
					this.slideDataFn(84,2)
				}else if(this.active == 3){
					// 幻想言情
					this.slideDataFn(103,3)
				}else if(this.active == 4){
					// 现代纯爱
					this.slideDataFn(121,4)
				}else if(this.active == 5){
					// 古代纯爱
					this.slideDataFn(112,5)
				}else if(this.active == 6){
					// 幻想纯爱
					this.slideDataFn(130,6)
				}else if(this.active == 8){
					// 衍生纯爱
					this.slideDataFn(157,8)
				}else if(this.active == 9){
					// 衍生言情
					this.slideDataFn(148,9)
				}
			},
			backForum() {
				this.$router.push('/bookcity')
			},
			jumpBookinfo(id){
				this.$router.push({path:'/bookinfo',query:{id:id,url:'yjjbPage'}})
			},
			slideDataFn(id,idx){
				this.$axios.post(`${this.$api.ranking_jb}?plate_id=${id}`).then(res => {
					console.log(res)
					if(res.data.data.length != 0){
						for(var i= 0;i<this.detialList.length;i++){
							this.detialList[idx].detial=res.data.data;
						}
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.tieziInfoBox {
		background-color: #fff;
		height: 100vh;
		overflow: hidden;

		// 头部
		.headerBox {
			height: 160px;
			background-color: #ff4081;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
			background-size: 100%;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.headerQuery {
				margin-top: 80px;
				padding: 0 20px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;

				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}

				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}

		}

		.main {
			display: flex;
			height: 100vh;
			font-size: 28px;/*px*/
			overflow-y: scroll;
			.wrapper {
				overflow: hidden;
				width: 150px;
				height: 100%;
				background-color: #f9f9f9;

				.content {
					padding-top: 40px;
					padding-bottom: 80px;
					font-size: 30px;/*px*/
					color: #3c3c3c;
					background-color: #f9f9f9;
					li {
						height: 80px;
						width: 150px;
						line-height: 80px;
						text-align: center;
					}

					.active {
						color: #ff4081;
						border-left: 4px solid #ff4081;
						/*no*/
						background-color: #fff;
					}
				}
			}

			.detialList_box {
				flex: 1;
				overflow-x: hidden;
				overflow-y: scroll;
				height: calc(100vh - 200px);
				margin: 0 8px;
				background-color: #fff;

				//列表数据
				.blockBox {
					overflow: hidden;
					position: relative;
					background-color: #fff;
					padding: 0px 16px;

					.blockLeft {
						display: flex;
						background-color: #fff;
						padding: 20px 0px;
						padding-bottom: 20px;
						border-bottom: 1px solid #f0f0f0;/*no*/
						clear: both;
						.book_Img {
							img {
								height: 280px;
								width: 172px;
								display: block;
								float: left;
								-webkit-box-shadow: 0 0 3px 0 rgba(0,0,0,.3);/*no*/
								-moz-box-shadow: 0 0 3px 0 rgba(0,0,0,.3);/*no*/
								box-shadow: 0 0 3px 0 rgba(0,0,0,.3);/*no*/
							}
						}

						.blockBookInfo {
							margin-left: 10px;
							flex: 1;
							font-size: 26px;
							/*px*/
							line-height: 30px;

							.auther {
								color: #676767;
								font-size: 28px;
								/*px*/
								width: calc(100vw - 380px);
								p {
									display: inline-block;
									float: right;
									font-weight: 400;
									span {
										margin-left: 8px;
										color: #000;
										font-size: 26px;
										/*px*/
									}
								
									// .wanjie {
									// 	color: #ff0000;
									// }
								
									// .txtGreen {
									// 	color: #5ca615;
									// }
								}
							}

							.bookName {
								padding-bottom: 20px;
								font-size: 30px;
								/*px*/
								font-weight: 700;
								color: #000000;
								position: relative;
								// p:first-of-type{
								// 	width: 150px;
								// 	overflow: hidden;
								// 	height: 30px;/*px*/
								// 	line-height: 30px;/*px*/
								// 	-webkit-line-clamp: 1;
								// 	-moz-line-clamp: 1;
								// 	line-clamp: 1;
								// }
								// p:last-of-type {
								// 	position: absolute;
								// 	top: 0;
								// 	right: 60px;
								// 	font-weight: 400;
								// 	float: right;
								// 	span {
								// 		margin-left: 8px;
								// 		color: #4c4c4c;
								// 		font-size: 26px;
								// 		/*px*/
								// 	}
								// }
								.bookTxtBox {
									width: calc(100vw - 380px);
									font-size: 30px;
									/*px*/
									color: #000;
									overflow: hidden;
									display: inline-block;
									.van-swipe .van-swipe__track--vertical .van-swipe-item {
										overflow: hidden;
										white-space: nowrap;
										text-overflow: ellipsis;
									}
								
									.van-notice-bar {
										background: rgba(0, 0, 0, 0);
										color: #000;
										height: 30px;
										padding: 0;
									}
								}
							}

							.bookType,
							.introduction {
								padding-top: 20px;
								color: #a3a3a3;
								-webkit-line-clamp: 2;
								line-clamp: 2;
							}

							.introduction {
								width: 60vw;
								padding-top: 15px;

								p {
									overflow: hidden;
									white-space: nowrap;
									text-overflow: ellipsis;
								}
							}

							.book_button {
								margin-top: 25px;
								width: calc(100vw - 380px);
								button {
									outline: none;
									border: 0;
									border: 1px solid #fec6d5;
									/*no*/
									border-radius: 28px;
									padding: 0px 20px;
									display: inline-block;
									background-color: #fff8fa;
									color: #fa7298;
									margin-right: 20px;
									font-size: 22px;
									/*px*/
									margin-bottom:10px;
								}

								.active {
									background-color: #fa7298;
									color: #ffffff;
								}
							}
						}
					}

				}

				.padding_color {
					background-color: #efeff4;
					height: 100%;
				}
			}


		}
	}
</style>
